// extracted by mini-css-extract-plugin
export default {"dockedChatContainer":"DockedChatContainer_dockedChatContainer__Po5yk","resizeHandle":"DockedChatContainer_resizeHandle__ps6iN"};